import { render, staticRenderFns } from "./ProcessDetailsHeader.vue?vue&type=template&id=c73fef88&scoped=true"
import script from "./ProcessDetailsHeader.ts?vue&type=script&lang=ts&external"
export * from "./ProcessDetailsHeader.ts?vue&type=script&lang=ts&external"
import style0 from "./ProcessDetailsHeader.vue?vue&type=style&index=0&id=c73fef88&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c73fef88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c73fef88')) {
      api.createRecord('c73fef88', component.options)
    } else {
      api.reload('c73fef88', component.options)
    }
    module.hot.accept("./ProcessDetailsHeader.vue?vue&type=template&id=c73fef88&scoped=true", function () {
      api.rerender('c73fef88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Processes/components/details/ProcessDetailsHeader/ProcessDetailsHeader.vue"
export default component.exports